// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__MR8bL","modalContent":"Modal_modalContent__dJP9O","close":"Modal_close__YIfx-"};